import React from "react";

const ImeiTableSkeleton = ({ rows = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={index} className="imei-skeleton-row">
          <td>
            <div className="skeleton-text skeleton-record-no"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-date"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-supplier"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-notes"></div>
          </td>
          <td>
            <div className="skeleton-text skeleton-numbers"></div>
          </td>
          <td className="actions">
            <div className="action-buttons">
              <div className="skeleton-btn skeleton-action-btn"></div>
              <div className="skeleton-btn skeleton-action-btn"></div>
            </div>
          </td>
        </tr>
      ))}

      <style jsx>{`
        .skeleton-text {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-btn {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 6px;
          height: 2rem;
          width: 2rem;
        }

        .skeleton-record-no {
          width: 60px;
          height: 1.2rem;
        }

        .skeleton-date {
          width: 100px;
          height: 1.2rem;
        }

        .skeleton-supplier {
          width: 120px;
          height: 1.2rem;
        }

        .skeleton-notes {
          width: 200px;
          height: 1.2rem;
        }

        .skeleton-numbers {
          width: 40px;
          height: 1.2rem;
        }

        .skeleton-action-btn {
          width: 32px;
          height: 32px;
          border-radius: 6px;
        }

        .imei-skeleton-row {
          border-bottom: 1px solid #f1f5f9;
        }

        .imei-skeleton-row td {
          padding: 16px 20px;
          vertical-align: middle;
        }

        .action-buttons {
          display: flex;
          gap: 10px;
          align-items: center;
          justify-content: flex-end;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .skeleton-record-no {
            width: 50px;
          }
          
          .skeleton-date {
            width: 80px;
          }
          
          .skeleton-supplier {
            width: 100px;
          }
          
          .skeleton-notes {
            width: 150px;
          }
          
          .skeleton-numbers {
            width: 35px;
          }
        }

        @media (max-width: 576px) {
          .skeleton-record-no {
            width: 40px;
          }
          
          .skeleton-date {
            width: 70px;
          }
          
          .skeleton-supplier {
            width: 80px;
          }
          
          .skeleton-notes {
            width: 120px;
          }
          
          .skeleton-numbers {
            width: 30px;
          }
        }
      `}</style>
    </>
  );
};

export default ImeiTableSkeleton;
